import Header from "../../../layouts/AuthLayout/header/header";
import CustomersSection from "./customers-section";

export default function CustomersPage() {
  return (
    <>
      <Header />
      <CustomersSection />
    </>
  );
}
